import React, { Component } from 'react';
// import CardHeader from '@material-ui/core/CardHeader';
// import Divider from '@material-ui/core/Divider';
import { CardMedia, CardContent, Card, Grid } from '@material-ui/core';
import { ThumbUp, ThumbDown, ThumbsUpDown } from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';
import { createComponent as cc } from 'react-fela';
import LinkWithoutDecoration from '../wrappers/LinkWithoutDecoration';

const CardMediaWrapper = cc(
  () => ({
    height: '100%',
  }),
  CardMedia,
  ['image'],
);

class UserCard extends Component {
  renderFedbackCount = (numberOfNeutralFeedback, thumbsUp, thumbsDown) => (
    <Grid container spacing={8}>
      <Grid item xs={4}>
        <Grid container alignContent="center" justify="space-around">
          <ThumbsUpDown
            color={numberOfNeutralFeedback ? 'inherit' : 'disabled'}
          />

          <Typography variant="title" align="center">
            {numberOfNeutralFeedback}
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={4}>
        <Grid container alignContent="center" justify="space-around">
          <ThumbUp color={thumbsUp ? 'primary' : 'disabled'} />

          <Typography variant="title" align="center">
            {thumbsUp}
          </Typography>
        </Grid>
      </Grid>

      <Grid item xs={4}>
        <Grid container alignContent="center" justify="space-around">
          <ThumbDown color={thumbsDown ? 'error' : 'disabled'} />

          <Typography variant="title" align="center">
            {thumbsDown}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );

  render() {
    const {
      email,
      userName,
      thumbsUp,
      numberOfNeutralFeedback,
      thumbsDown,
      userId,
      avatarMedUrl,
    } = this.props;
    return (
      <LinkWithoutDecoration to={`/users/${userId}`}>
        <Card>
          <Grid container direction="row">
            <Grid item xs={6}>
              <CardContent>
                <Typography variant="title" align="center">
                  {userName}
                </Typography>
                <Typography variant="subheading" align="center">
                  {email}
                </Typography>
              </CardContent>
              <CardContent>
                {this.renderFedbackCount(
                  numberOfNeutralFeedback,
                  thumbsUp,
                  thumbsDown,
                )}
              </CardContent>
            </Grid>
            <Grid item xs={6}>
              <CardMediaWrapper image={avatarMedUrl} />
            </Grid>
          </Grid>
        </Card>
      </LinkWithoutDecoration>
    );
  }
}

export default UserCard;



// WEBPACK FOOTER //
// ./src/components/userList/UserCard.js